import CustomDataTable from 'general/components/CustomDataTable'
import DraggableModal from 'general/components/Modal/DragableModal/DraggableModal'
import { useRef, useState } from 'react'
import customDataTableStyle from 'assets/styles/customDataTableStyle'
import { PACKAGE_TYPE, RESOURCE_TYPE } from 'general/constants/AppConstants'
import { useQuery } from '@tanstack/react-query'
import { queryKeys } from './queries'
import { current } from '@reduxjs/toolkit'
import AppResource from 'general/constants/AppResource'
import { Button } from 'antd'


export const BuyResourceModal = (props) => {
  const { show, setShow } = props
  const ref = useRef(null)

  const packageServiceColumns = [
    // {
    //   id: 'index',
    //   name: 'STT',
    //   center: true,
    //   minWidth: '20px',
    //   cell: (row, index) => index + 1,
    // },
    {
      id: 'packageName',
      name: 'Mã gói',
      center: true,
      minWidth: '100px',
      cell: ({ packageName }) => packageName,
    },
    {
      id: 'packageName',
      name: 'Gói dịch vụ',
      center: true,
      minWidth: '200px',
      format: ({ invoiceType, packageType }) => {
        if (packageType === PACKAGE_TYPE.DURATION) {
          return 'Truyền nhận hoá đơn điện tử'
        }
        switch (invoiceType) {
          case RESOURCE_TYPE.INVOICE:
            return 'Hóa đơn điện tử - Hoá đơn, PXK'
          case RESOURCE_TYPE.TICKET:
            return 'Hoá đơn điện tử - Vé điện tử'
          case RESOURCE_TYPE.PERSONAL_INCOME:
            return 'Hoá đơn điện tử - Chứng từ TNCN'
          default:
            return 'Truyền nhận hoá đơn điện tử'
        }
      },
      selector: ({ invoiceType }) => invoiceType,
    },
    {
      id: 'duration',
      name: 'Tài nguyên',
      center: true,
      minWidth: '70px',
      cell: ({ duration }) => `${duration} ngày`,
    },
    {
      id: 'bonusResourceName',
      name: 'Tặng thêm',
      center: true,
      minWidth: '70px',
      cell: ({ bonus }) => bonus,
    },
    {
      id: 'packageCost',
      name: 'Giá bán (VNĐ)',
      center: true,
      minWidth: '90px',
      cell: ({ packageCost }) => packageCost,
    },
  ]

  const buyResourceTableStyle = {
    ...customDataTableStyle,
    headCells: {
      style: {
        ...customDataTableStyle.headCells.style,
        fontSize: '0.8rem',
        fontWeight: 600,
      },
    },
    cells: {
      style: {
        ...customDataTableStyle.cells.style,
        fontSize: '12px',
      },
    },
  }
  const [tableState, setTableState] = useState({
    currentPage: 1,
    rowsPerPage: 5,
  })

  const { data: dataSource, isLoading: gettingListData } = useQuery({
    ...queryKeys.getDurationPackages({
      page: 0,
      limit: 5,
      packageType: 'DURATION',
      orderPackageType: 'EXTEND',
      invoiceType: 'INVOICE',
    }),
  })

  const [selectedPackage, setSelectedpackage] = useState({})
  return (
    <DraggableModal
      isOpen={show}
      title="Chọn mua gói dịch vụ"
      onOpenChange={() => {
        setShow(false)
      }}
      hasApplyButton={false}
      ref={ref}
      styles={{
        body: {
          padding: '0px',
        },
      }}
      width={900}
    >
      <div className="buy-resource row" style={{ padding: '0 20px' }}>
        <div className="col-9">
          <span
            className="sub-title-buy-resource"
            style={{ fontWeight: '600', fontSize: '16px' }}
          >
            Tài nguyên mua thêm
          </span>
          <CustomDataTable
            wrapperClassName="my-5"
            customTableStyle={buyResourceTableStyle}
            columns={packageServiceColumns}
            dataSource={dataSource ? dataSource.rows : []}
            isSelectable={true}
            selectedRows={{
              handleSelectedRows: ({ selectedRows }) => {
                setSelectedpackage(selectedRows[0])
              },
              clearSelectedRows: true,
            }}
            pagination={{
              currentPage: tableState.currentPage,
              rowsPerPage: 5,
              total: dataSource?.total || 0,
              onChangePage: (page) => {
                setTableState((prev) => ({
                  ...prev,
                  currentPage: page,
                }))
              },
              // onChangeRowsPerPage: (limit) => {
              //   setFilters({
              //     ...filters,
              //     limit,
              //     page: 1,
              //   })
              // },
            }}
            // scrollY="250px"
          />
        </div>
        <div className="col-3">
          <span
            className="sub-title-buy-resource"
            style={{ fontWeight: '600', fontSize: '16px' }}
          >
            Thông tin thanh toán
          </span>
          <div className="payment-info my-5">
            {selectedPackage?.packageName ? (
              <>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span>
                    Phí truyền nhận hóa đơn điện tử -{' '}
                    {selectedPackage?.packageName}
                  </span>
                  <span>{selectedPackage?.packageCost}</span>
                </div>
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span>Tổng thanh toán:</span>
                  <span>{selectedPackage?.packageCost}</span>
                </div>
                <div>
                  <h6>Phương thức thanh toán</h6>
                  <input type="radio" id="vnpay" name="paymentMethod" />
                  <label className="mx-2" for="vnpay">
                    <img src={AppResource.logoIcon.vn_pay} alt="" width={160} />
                  </label>
                  <br />
                  <input type="radio" id="momo" name="paymentMethod" />
                  <label className="mx-2" for="momo">
                    <img src={AppResource.logoIcon.momo} alt="" width={160} />
                  </label>
                  <br />
                  <Button className="mt-4 w-100 bg-blue" variant="primary">
                    Thanh toán ngay 
                  </Button>
                </div>
              </>
            ) : (
              <p>Vui lòng chọn gói dịch vụ</p>
            )}
          </div>
        </div>
      </div>
    </DraggableModal>
  )
}
